import { useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { ArrowIcon, Seo, Wordmark } from '../components/shared';

// Anchors that used to live on the old single-page homepage.
const LEGACY_ANCHORS = ['#services', '#seasonal-packages', '#referrals'];

const HINTS = {
  none: 'Pick a side to continue',
  students: 'Continue as a student',
  owners: 'Continue as a home owner',
};

export default function ChooserPage() {
  const { hash } = useLocation();
  const [active, setActive] = useState('none');

  if (LEGACY_ANCHORS.includes(hash)) {
    return <Navigate to={`/home-owners${hash}`} replace />;
  }

  const half = (side) => ({
    onMouseEnter: () => setActive(side),
    onMouseLeave: () => setActive('none'),
    onFocus: () => setActive(side),
    onBlur: () => setActive('none'),
  });

  return (
    <>
      <Seo />
      <div className="chooser" data-active={active === 'none' ? undefined : active}>
        <h1 className="visually-hidden">Connecting Students With Landscaping For Your Home</h1>

        <div className="chooser__logo">
          <Wordmark />
        </div>

        <div className="chooser__split">
          <Link to="/students" className="chooser__half chooser__half--students" {...half('students')}>
            <img className="chooser__img" src="/photos/chooser-students.jpg" alt="" width="1600" height="1066" loading="eager" />
            <div className="chooser__veil" />
            <div className="chooser__content">
              <div className="eyebrow">For students</div>
              <h2 className="chooser__title">Work anytime. Get paid.</h2>
              <p className="chooser__text">
                Lawn care, yard cleanups and snow clearing in your own neighbourhood. Take the jobs that fit around your schedule.
              </p>
              <span className="btn chooser__cta">Apply to work <ArrowIcon size={17} /></span>
            </div>
          </Link>

          <Link to="/home-owners" className="chooser__half chooser__half--owners" {...half('owners')}>
            <img className="chooser__img" src="/photos/striped-backyard.jpg" alt="" width="1600" height="1200" loading="eager" />
            <div className="chooser__veil" />
            <div className="chooser__content">
              <div className="eyebrow">For home owners</div>
              <h2 className="chooser__title">Hand the yard to a student.</h2>
              <p className="chooser__text">
                Mowing, weeding, cleanups and snow removal, done by vetted students from your area. Tell us the job and we quote it.
              </p>
              <span className="btn chooser__cta">Get a free quote <ArrowIcon size={17} /></span>
            </div>
          </Link>
        </div>

        <div className="chooser__hint" aria-hidden="true">
          <span>{HINTS[active]}</span>
        </div>
      </div>

      <section className="seo-band">
        <div className="wrap">
          <p>
            Student For Hire connects homeowners with local students for lawn mowing, weeding and gardening, leaf cleanups,
            window washing, snow removal, pressure washing and furniture moving.
          </p>
          <ul aria-label="Services">
            <li>Lawn mowing</li>
            <li>Weeding and gardening</li>
            <li>Leaf cleanups</li>
            <li>Window washing</li>
            <li>Snow removal</li>
            <li>Pressure washing</li>
            <li>Furniture moving</li>
          </ul>
        </div>
      </section>
    </>
  );
}
